import { render } from "./MentionTextarea.vue?vue&type=template&id=067504ea&scoped=true"
import script from "./MentionTextarea.vue?vue&type=script&lang=js"
export * from "./MentionTextarea.vue?vue&type=script&lang=js"

import "./MentionTextarea.vue?vue&type=style&index=0&id=067504ea&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-067504ea"]])

export default __exports__